import DataTable from './components/DataTable'
export * from './utils/renderers'
export default DataTable


